import React, { useEffect, useState } from "react";
import {
  getPaymentSummary,
  getVisitTransactions,
  getVisit,
} from "../../apis/visit";
import { useParams } from "react-router-dom";
import PaymentModal from "../../components/PaymentModal"; 
import { format } from "date-fns";
const VisitTransactionList = () => {
  const params = useParams();
  const [editableId, setEditableId] = useState(null);

  const [transactions, setTransactions] = useState<Array<any>>([]);
  const [isTransactionModalOpen, setTransactionModalVisibility] =
    useState<boolean>(false);
  const [total, setTotal] = useState<any>();
  const [amountPaid, setAmountPaid] = useState<any>();
  const [amountDue, setAmountDue] = useState<any>();
  const [discount, setDiscount] = useState<any>();
  const [invoice, setInvoice] = useState<any>();
  const [visitData, setVisitData] = useState<any>(null);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);

  useEffect(() => {
    if (params.visitId) {
      fetchTransactions();
      getVisitTotal();
      fetchVisitData();
    }
  }, [params.visitId]);

  const fetchVisitData = () => {
    if (params.visitId) {
      getVisit(Number(params.visitId)).then((res: any) => {
        setVisitData(res);
      });
    }
  };

  const fetchTransactions = () => {
  getVisitTransactions(params.visitId).then((res: any) => {
    const invoiceData = res?.data?.invoice;

    setInvoice(invoiceData);
    setTransactions(invoiceData?.transactions || []); 
  });
};

  const handleCloseModal = () => {
    setEditableId(null);
    setTransactionModalVisibility(false);
    fetchTransactions();
  };

  const handleEditTransaction = (payload: any) => {
    setEditableId(payload.id);
    setTransactionModalVisibility(true);
  };

  const getVisitTotal = () => {
    getPaymentSummary(params.visitId).then((res: any) => {
      const visitTransactions = res.data.data;
      setTotal(visitTransactions.total);
      setAmountPaid(visitTransactions.amountPaid);
      setAmountDue(visitTransactions.amountDue);
      setDiscount(visitTransactions.discount);
    });
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Transactions
            {/* {JSON.stringify(invoice)} */}
          </h1>
          <div className="grid gap-2">
            <p className="mt-1 text-sm text-gray-500">
              Total Amount:{" "}
              <span className="font-semibold text-gray-800">
                ₹{invoice?.totalAmount || 0}
              </span>
              <span className="mt-1 ml-6 text-sm text-gray-500">
                Status:{" "}
                <span className="font-semibold text-gray-800 capitalize">
                  {invoice?.status}
                </span>
              </span>
            </p>
            <p className="mt-1 text-sm text-gray-500">
              Amount Paid:{" "}
              <span className="font-semibold text-gray-800">
                ₹{invoice?.paidAmount || 0}
              </span>
              <span className="mt-1 ml-6 text-sm text-gray-500">
                Amount Due:{" "}
                <span className="font-semibold text-gray-800">
                  ₹{invoice?.totalAmount - invoice?.paidAmount || 0}
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="mx-2 mt-4 sm:mt-0 sm:ml-16 sm:flex">
          <button
            type="button"
            // onClick={() => setTransactionModalVisibility(true)}
            onClick={() => setIsPaymentOpen(true)}
            className="block px-3 py-2 text-sm font-semibold text-center text-white rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Create New
          </button>
        </div>
      </div>
      <div className="flow-root mt-8">
        <div className="overflow-x-auto -mx-4 -my-2 sm:-mx-6 lg:-mx-8">
          <div className="inline-block py-2 min-w-full align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden ring-1 ring-black ring-opacity-5 shadow sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Receipt No.
                    </th>

                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Amount
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Payment Mode
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Payment Note
                    </th>

                    {/* <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Action
                    </th> */}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {transactions &&
                    transactions.map((transaction, index) => (
                      <tr key={index}>
                        <td className="py-4 pr-3 pl-4 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-6">
                          <div className="font-medium">
                            {transaction.receiptNumber}
                          </div>
                          <div className="text-xs text-gray-500">
                            {transaction.createdAt &&
                              format(
                                new Date(transaction.createdAt),
                                "dd MMM yyyy"
                              )}
                          </div>
                        </td>

                        <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                          ₹{transaction.amount}
                        </td>
                        <td className="px-3 py-4 text-sm text-gray-500 capitalize whitespace-nowrap">
                          {transaction.paymentMode}
                        </td>
                        <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">
                          {transaction.notes ? transaction.notes : "--"}
                        </td>

                        {/* <td className="relative py-4 pr-4 pl-3 text-sm font-medium text-left whitespace-nowrap sm:pr-6">
                          <button
                            onClick={() => handleEditTransaction(transaction)}
                            className="text-indigo-600 hover:text-indigo-900"
                          >
                            Edit
                          </button>
                        </td> */}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {/* {isTransactionModalOpen && (
        <Modal
          title={editableId ? "Update Transaction" : "Add Transaction"}
          onClose={() => handleCloseModal()}
          modalContent={
            <AddVisitTransaction
              visitId={null}
              editableId={editableId}
              closeModal={() => handleCloseModal()}
              patientId={visitData?.patientId}
              invoiceNumber={visitData?.invoiceNumber}
            />
          }
        />
      )} */}
      {isPaymentOpen && (
        <PaymentModal
          isOpen={isPaymentOpen}
          onClose={() => setIsPaymentOpen(false)}
           total={total || 0}          
           discount={discount || 0}   
          patientId={visitData?.patientId}
          patientName={
            visitData?.patient
              ? `${visitData.patient.firstName} ${visitData.patient.lastName}`
              : undefined
          }
          sourceType="visit"
          sourceId={Number(params.visitId)}

          onPaymentSuccess={() => {
            fetchTransactions();
            getVisitTotal();
          }}
        />
      )}
    </div>
  );
};

export default VisitTransactionList;
